import * as React from 'react'

import {Button, Form} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../src/styles/common.scss';
import {InformationStore} from "../../../src/store/views/Information/InformationStore";
import {loginUserStore} from "../../store/Login/LoginUserStore";
import appStyles from '../../assets/css/app.scss';
import {observable} from "mobx";
import {redirect} from "../../../src/common/Router/routerCommon";
import {getQueryParam} from "../../../src/utils/react/routerUtil";

const FormItem = Form.Item;

@observer
class PermitError extends ViewBaseComponent<{} & FormComponentProps, {}> {
  informationStore: InformationStore | undefined;
  formUtils = this.props.form;

  @observable
  remaining = 0;

  @observable
  isModalVisible = false;

  componentWillMount() {
    this.informationStore = new InformationStore();

    loginUserStore.getLoginUser().then(() => {
    });
  }

  componentWillUnmount() {
    this.informationStore = void 0
  }

  render() {
    return (
      <><KixGbcMemberLayout>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>
          {getQueryParam("is_lane") == "1" ? "Fast Lane" : "ラウンジ"}
          を利用する</h2>

        <Form>
          <div className={commonStyles.fCenter} style={{marginBottom: "2em"}}>
            <span className={appStyles.h3White}>エラー</span>
          </div>
          <div className={commonStyles.fCenter} style={{marginBottom: "2em"}}>
            {getQueryParam("is_lane") == "1"
              ? <>
                <span className={appStyles.h3White}>利用回数が制限に達しているため、<br/>
               「Fast Lane」をご利用いただけません。</span>
              </>
              : <>
                <span className={appStyles.h3White}>利用回数が制限に達しているため、<br/>
                「KIXエアサイドラウンジ」「KIXノースラウンジ」をご利用いただけません。</span>
              </>}

          </div>
          <div className={commonStyles.fCenter} style={{marginBottom: "2em"}}>
            <FormItem>
              <Button
                style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0", color: "#e2007e", fontWeight: "bold"}}
                type="primary"
                size="large" className={appStyles.buttonWhite}
                onClick={() => redirect(`/`)}
              >
                戻る
              </Button>
            </FormItem>
          </div>
        </Form>
      </KixGbcMemberLayout>
      </>
    );
  }
}

export default Form.create()(PermitError)

